import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { SaltProvider } from "@salt-ds/core";
import "ag-grid-community/styles/ag-grid.css";
import "@salt-ds/ag-grid-theme/salt-ag-theme.css";
import "@salt-ds/theme/index.css";
import App from "./app/App.tsx";
import "./index.css";
import store from "./store/store.ts";
import ErrorPage from "./app/ErrorPage";
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/300-italic.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/400-italic.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/500-italic.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/600-italic.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/open-sans/700-italic.css";
import "@fontsource/open-sans/800.css";
import "@fontsource/pt-mono";


ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <ErrorBoundary
      FallbackComponent={ErrorPage}
      onReset={() => {
        window.location.reload();
      }}
    >
      <Provider store={store}>
        <SaltProvider>
          <App />
        </SaltProvider>
      </Provider>
    </ErrorBoundary>
  </BrowserRouter>
);
